import {mapGetters} from "vuex";
import {Dealer, StructuralSubdivisionUser} from "../config/roles";

export default {
 computed: {
     ...mapGetters('account', ['role', 'isCurrentUserDealer', 'isCurrentUserStructuralSubdivisionUser'])
 }
}